import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';
import { removeReadOnlyFields } from 'src/utils/fieldNormalizers';

import { Service } from './_types';

const serviceReadOnlyFields = [
  'tags',
  'service_resources',
  'calendar_id',
  'thumbnail',
  'close_after_toggle',
  'large_thumbnail',
  'id',
  'card_required'
];

export function normalizeService(service): Service {
  const camelized = camelcaseKeys(service, { deep: true });
  return {
    ...camelized,
  };
}

export function denormalizeService(service): Service {
  const data = {
    ...service,
    tagList: [...new Set(service.tags || [])].join(','),
    service_resources_attributes: (service.serviceResources || []).map((sr) => ({
      id: sr.id,
      resourceId: sr.resource?.id || null,
      serviceId: sr.serviceId || null,
      subResourceIds: sr.subResourceIds,
      usageBehavior: sr.usageBehavior,
      _destroy: sr._destroy || undefined,
    })),
    minimumVisits: service.minimumVisits || null,
    noshowFee: service.noshowFee || null,
    cancellationFee: service.cancellationFee || null,
    zoom: service.zoom || null,
    cancellationPolicyHours: service.cancellationPolicyHours || null,
    assessmentId: service.assessmentId || null,
    assessmentSequenceId: service.assessmentSequenceId || null,
  };
  if (service.defaultCommissionType && !service.defaultCommission) {
    data.defaultCommissionType = null;
  }
  if (!service.defaultCommission && !service.defaultCommissionType) {
    data.defaultCommission = null;
    data.defaultCommissionType = null;
  }

  if (
    service.defaultSecondaryCommissionType &&
    !service.defaultSecondaryCommission
  ) {
    data.defaultSecondaryCommissionType = null;
  }
  if (
    !service.defaultSecondaryCommission &&
    !service.defaultSecondaryCommissionType
  ) {
    data.defaultSecondaryCommission = null;
    data.defaultSecondaryCommissionType = null;
  }

  const camelized = decamelizeKeys(data, { deep: true });

  removeReadOnlyFields(camelized, serviceReadOnlyFields);

  return {
    ...camelized,
  };
}

